<formio *ngIf="form" class="formviewer" [refresh]="triggerRefresh" #formViewer [renderOptions]="renderOptions" [form]="form"
  [options]="options">
</formio>
<script src="https://cdn.jsdelivr.net/npm/choices.js/public/assets/scripts/choices.min.js"></script>
